<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-模拟显示-顶部设置栏
    -->
  <div class="phone-top" v-if="diyData.page" @click.stop="$parent.onEditer(-1)" :style="'background:' + diyData.page.style.titleBackgroundColor">
    <div class="status-bar">
      <span><Icon :iconname="'#icon-wifi'" :style="'color:' + diyData.page.style.titleTextColor"></Icon></span>
      <span class="time" :style="'color:' + diyData.page.style.titleTextColor">19:00</span>
      <span>
        <Icon :iconname="'#icon-xinhao'" :style="'color:' + diyData.page.style.titleTextColor"></Icon>
        <Icon class="ml4" :iconname="'#icon-iconset0250'" :style="'color:' + diyData.page.style.titleTextColor"></Icon>
      </span>
    </div>
    <div class="navigation" :style="'color:' + diyData.page.style.titleTextColor">{{ diyData.page.params.title }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    diyData: Object
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Setpages.vue